<template>
  <div id="tailwind" class="TAILWIND !block relative" style="display: none">
    <div class="text-base min-h-screen flex flex-col relative">
      <Navbar class="shrink-0"/>
      <router-view class="grow bg-gray-50 relative flex"/>
      <ActionToast/>

      <ContainerOptions/>
    </div>
  </div>
</template>

<script>

import Navbar from '../../components/SideEditor/Navbar/Navbar.vue'
import ActionToast from '../../components/SideEditor/ActionToast.vue'
import ContainerOptions from '../../components/SideEditor/ContainerOptions/ContainerOptions.vue'
import GlobalTranslationsTable from "@/components/SideEditor/GlobalTranslationsTable/GlobalTranslationsTable"

import { mapGetters } from "vuex"
import { mergeDeep } from "@/utils/editor"

const removeStyles = []

const migrateBlocks = (blocks) => {
  const obj = {}

  blocks.filter(item => item).forEach(el => {
    const pushArr = role => {
      if (obj[role]) obj[role].push(el)
      else obj[role] = [el]
    }

    switch (el.id) {
      case "BasicNavbar": {
        pushArr('navbar')
        break;
      }
      case "BasicFooter": {
        pushArr('footer')
        break;
      }
      default: {
        pushArr('landing page')
        break;
      }
    }
  })

  return {default: obj}
}
const migrateContent = (content, collection) => {
  Object.keys(collection.default).forEach(role => {
    collection.default[role].forEach(block => {
      if (content[block.id]) {
        if (content[block.id].nl_NL) delete content[block.id].nl_NL
        block.content = content[block.id]
      }
    })
  })
}

export default {
  components: {
    ActionToast,
    GlobalTranslationsTable,
    Navbar,
    ContainerOptions,
  },
  created() {
    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/; SameSite=None; Secure";
    }
    setCookie("environment", "editor", 2)

    try {
      tailwind.config = {
        corePlugins: {
          // ...
          container: false,
        },
        plugins: [
          ({ addComponents, theme }) => {
            addComponents({
              ".container": {
                "@apply max-w-4xl lg:max-w-5xl xl:max-w-8xl px-2 mx-auto": {},
              },
            });
          },
        ],
        theme: {
          screens: {
            sm: 640 / 1.33333333 + 'px',
            md: 768 / 1.33333333 + 'px',
            lg: 1024 / 1.3333333 + 'px',
            xl: 1280 / 1.3333333 + 'px',
            '2xl': 1536 / 1.3333333 + 'px',
          },
          extend: {
            gridRow: {
              'span-7': 'span 7 / span 7',
              'span-8': 'span 8 / span 8',
              'span-9': 'span 9 / span 9',
              'span-10': 'span 10 / span 10',
              'span-11': 'span 11 / span 11',
              'span-12': 'span 12 / span 12',
            },
            gridTemplateRows: {
              '12': 'repeat(12, minmax(0, 1fr))',
            },
            colors: {
              primary: "#33C9D2",
            },
          },
        },
      }
    } catch (err) {
      location.reload()
    }

    this.loadDefaultConfig()
    this.removeAllStylesInProduction()

    this.$store.dispatch("editor/pushSaveListener", this.saveLandingPageConfig)
    this.$store.dispatch("editor/pushConfigLoader", this.loadDefaultConfig)
    this.$store.dispatch("editor/loadAvailablePackages")

    this.removeAllStyles()
    document.body.parentNode.style = "font-size: 12px"
  },
  mounted() {
    document.body.parentNode.style = "font-size: 12px"
  },
  beforeDestroy() {
    this.$store.dispatch("editor/removeSaveListener", this.saveLandingPageConfig)
    this.$store.dispatch("editor/removeConfigLoader", this.loadDefaultConfig)
    document.body.parentNode.style = "font-size: 16px"
  },
  methods: {
    async loadDefaultConfig() {
      await this.$store.dispatch("editor/load", this.$route.params.id)
    },
    removeAllStylesInProduction() {
      const links = [...document.head.querySelectorAll("link[href]")]
      for (const el of links) {
        if (
          el.href.includes(".css") &&
          !el.href.includes("prism-tomorrow.min.css")
        ) el.remove()
      }
    },
    removeAllStyles() {
      document.querySelectorAll("[type='text/css']").forEach(el => {
        const content = el.innerHTML
        if (
          content.includes(".fade-enter, .fade-leave-to") ||
          content.includes(".fade-enter, .fade-leave-to") ||
          content.includes(".VUETIFY") ||
          content.includes(".prism-language-markup")
        ) return;

        removeStyles.push(content)
        el.remove()
      })
    },
    async saveLandingPageConfig() {
      const availablePages = ['default', 'contact', 'physical-shops']
      const pages = {
        account: ['account'],
        catalog: ['catalog', 'catalog-search', 'catalog-product', 'catalog-all-categories'],
        authentication: ['authentication-login', 'authentication-register', 'authentication-forgotpassword', 'authentication-createpassword'],
        checkout: ['checkout-cart', 'checkout-address', 'checkout-payment-methods', 'checkout-success'],
      }

      Object.keys(pages).forEach(page => availablePages.push(...pages[page]))
      const availableTopKeys = ['blocks_collection', 'labels', 'tailwindConfig', 'translations', 'email_templates']

      const config = { ...this.config, blocks_collection: { ...this.config.blocks_collection } }
      Object.keys(config.blocks_collection).forEach(page => {
        if (!availablePages.includes(page)) {
          delete config.blocks_collection[page]
        }
      })
      Object.keys(config).forEach(topKey => {
        if (!availableTopKeys.includes(topKey)) {
          delete config[topKey]
        }
      })

      if (!config.tailwindConfig) config.tailwindConfig = {}

      try {
        await this.axios.put(`/api/websites/${this.website.uid}`, {
          properties: {
            wholesale: this.website.properties.wholesale === '0' ? false : true,
          },
          magento_config: JSON.stringify(config),
        })
        this.$store.dispatch('clearCacheSearch', "websites")
      } catch (err) {
        if (err && err.response && err.response.status === 401) {
          await this.axios.get("/logout")
          this.$store.commit("setUser", null)
          location.href = '/sign-in'
        }
        throw err
      }
    },
  },
  computed: {
    ...mapGetters({
      config: 'editor/config',
      website: 'editor/website',
      link: "editor/fullDomainLink",
    })
  },
  watch: {
    link() {
      if (this.link) {
        this.$store.dispatch("cachedGet", {
          endpoint: `${this.link}/rest/V1/editor/list-available-categories`,
          headers: { Cookie: 'environment=editor' },
        })
      }
    },
    config(config) {
      if (config && (config.blocks || config.content)) {
        const newConfig = mergeDeep(config)
        if (config.blocks) {
          newConfig.blocks = [...config.blocks, config.navbar, config.footer]
          if (!newConfig.blocks_collection) {
            newConfig.blocks_collection = migrateBlocks(newConfig.blocks)
          }

          delete newConfig.navbar
          delete newConfig.footer
          delete newConfig.blocks
        }

        if (newConfig.content) {
          migrateContent(newConfig.content, newConfig.blocks_collection)
          delete newConfig.content
        }

        this.$store.commit("editor/nonRecursiveConfig", newConfig)
      }
    },
  },
}

</script>
